import React from "react";
import ModalVideo from 'react-modal-video'
import 'react-modal-video/scss/modal-video.scss';

const PlayVideo = (props)  => {
    const isAutoPlay = props.isAutoPlay !== undefined ? (props.isAutoPlay ? 1 : 0) : 1;
    const isMute = props.isMute !== undefined ? (props.isMute ? 1 : 0) : (props.mute !== undefined ? (props.mute ? 1 : 0) : (isAutoPlay ? 1 : 0));

    // Helper to extract YouTube video ID from any format (id, embed, watch, shortlink)
    const getYouTubeId = (str) => {
        if (!str || typeof str !== "string") return "";
        if (str.includes("embed/")) return str.split("embed/")[1]?.split("?")[0]?.split("&")[0] || "";
        if (str.includes("v=")) return str.split("v=")[1]?.split("&")[0]?.split("?")[0] || "";
        if (str.includes("youtu.be/")) return str.split("youtu.be/")[1]?.split("?")[0]?.split("&")[0] || "";
        return str.split("&")[0]?.split("?")[0] || "";
    };

    const videoId = getYouTubeId(props.videoId) || (props.custumUrl && props.custumUrl !== 0 ? getYouTubeId(props.custumUrl) : "");
    const isYouTube = (props.custumUrl == 0 || !props.custumUrl) || Boolean(getYouTubeId(props.custumUrl));

    return (
        <>
        {isYouTube && videoId ? (
            <React.Fragment>
                <ModalVideo 
                    channel='youtube' 
                    isOpen={props.isOpen} 
                    videoId={videoId}
                    youtube={{
                        autoplay: isAutoPlay,
                        mute: isMute,
                        enablejsapi: 1
                    }}
                    onClose={ e => props.isCloseFunction(false)}
                />
            </React.Fragment>
        ) : (
            <React.Fragment>
                <ModalVideo 
                    channel='custom'
                    isOpen={props.isOpen} 
                    url={props.custumUrl}
                    onClose={ e => props.isCloseFunction(false)}
                />
            </React.Fragment>
        )}
        </>
    )
};

export default PlayVideo;
